module.exports = __webpack_public_path__ + "51858a54c65684243d464234d3b40044.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/overalls-red.png
// module id = 1978
// module chunks = 0